import type React from 'react';

import * as styles from './styles';
import Box from '@material-ui/core/Box';
import moment from 'moment';

import {
  IncidentTypes,
  type IncidentWithAddress,
} from '@cobliteam/common-types';

import {
  CaptionDefault,
  DescriptionListDefault,
  DescriptionTitle,
  InputLabel,
  UnpluggedIcon,
} from '@cobliteam/base-components';

export interface ListItemProps {
  incident: IncidentWithAddress;
}

export const ListItem: React.FC<ListItemProps> = ({ incident }) => {
  const {
    type,
    date,
    licensePlate,
    vehicleBrand,
    vehicleModel,
    driverName,
    address,
  } = incident;
  const isPlugged = type === IncidentTypes.DEVICE_PLUGGED;
  const titleTextVariation = isPlugged ? 'recolocado no' : 'desconectado do';
  // const devicesWebData = useSelector((state: AppState) => state.devices.devicesWebData);

  const getBrandAndModel = () => {
    const vehicleBrandAndModel = `${vehicleBrand || ''} ${
      vehicleModel || ''
    }`.trim();
    return vehicleBrandAndModel || 'Sem marca e modelo cadastrado';
  };

  // TODO: uncomment this method when fixing the vehicle id verification
  // const handleClick = () => {
  //   const vehicleId = isWebDataSuccess(devicesWebData)
  //     ? devicesWebData.data.find(device => device.esn === deviceId)?.vehicle.id
  //     : null;

  //   if (vehicleId) {
  //     const params = queryString.stringify({
  //       vehicle_id: vehicleId,
  //       date,
  //       event_type: 'incident',
  //       event_time: date,
  //     });
  //     const url = `${window.location.origin}${Location.TRACKING}?${params}`;
  //     window.open(url, '_blank');
  //   }
  // };

  return (
    <Box className={styles.listItem}>
      <div className={styles.listItemRow}>
        <DescriptionTitle>
          Dispositivo {titleTextVariation} veículo
        </DescriptionTitle>
        {!isPlugged && <UnpluggedIcon className={styles.unpluggedIcon} />}
      </div>

      <div className={styles.listItemRow}>
        <InputLabel className={styles.inputLabel}>Veículo:</InputLabel>
        <DescriptionListDefault className={styles.descriptionList}>
          {licensePlate} - {getBrandAndModel()}
        </DescriptionListDefault>
      </div>

      <div className={styles.listItemRow}>
        <InputLabel className={styles.inputLabel}>Motorista:</InputLabel>
        <DescriptionListDefault className={styles.descriptionList}>
          {driverName || 'Sem motorista associado'}
        </DescriptionListDefault>
      </div>

      <div className={styles.listItemRow}>
        <InputLabel className={styles.inputLabel}>Local:</InputLabel>
        <DescriptionListDefault className={styles.descriptionList}>
          {address}
        </DescriptionListDefault>
      </div>

      <CaptionDefault className={styles.listItemRow}>
        {moment(date).format('DD/MM/YY [às] HH:mm')}
      </CaptionDefault>
    </Box>
  );
};
